import React, { useEffect, useState } from 'react';
import ReactApexChart from 'react-apexcharts';
import useWindowDimensions from '../../../utils/useWindowDimensions';

const Productivity = ({page, labels, guidedCounts, unguidedCounts, seriesName1 , seriesName2 }) => {
    let {width , height} = useWindowDimensions();

    

    const [chartOptions , setChartOptions] = useState({});

    const [chartSeries , setChartSeries] = useState([
    {
      name: seriesName1,
      data: guidedCounts,
    },
    {
      name: seriesName2,
      data: unguidedCounts,
    },
      ]);

    useEffect(()=>{
        setChartOptions({
          chart: {
              type: 'bar',
              width: '100%',
              toolbar: {
                  show: false
              },
          },

      plotOptions: {
        bar: {
          horizontal: false,
          columnWidth: "55%",
          endingShape: "rounded",
        },
      },
      dataLabels: {
        enabled: false,
      },
      stroke: {
        show: true,
        width: 2,
        colors: ["transparent"],
      },
      xaxis: {
        categories: labels,
        tickAmount:15
      },
      fill: {
        opacity: 1,
      },
      tooltip: {
        y: {
          formatter: function (val) {
            return   val ;
          },
        },
      },
      colors: ["#3e4095", "#333333"],

         });
        setChartSeries([
          {
            name: seriesName1,
            data: guidedCounts,
          },
          {
            name: seriesName2,
            data: unguidedCounts,
          },
            ]);
      },[ labels,guidedCounts,unguidedCounts])



    return (
        <>
            <div id="chart">
              { page == "myDashboard" ?
                <ReactApexChart options={chartOptions} series={chartSeries} type="bar" height={width > 1400 && width < 1650 ? 250 : width > 1650 ? 300 : 198} />
                :
                <ReactApexChart options={chartOptions} series={chartSeries} type="bar" height={width > 1500 ? 250 : 198 } />
              }
            </div>
        </>
    )
}

export default Productivity;
